import type { NpcHullTierLabel } from "./types";

// In-Location top speed (design doc Section 2a, "Location sizing & ship
// speed -- LOCKED (EVE-anchored numeric pass)") -- distinct from
// shipSpeed.ts's hop time, which is explicitly scoped to travel *between*
// Locations/Systems, not movement *within* one.
export const HULL_SIZE_BASE_SPEED_MPS: Record<NpcHullTierLabel, number> = {
  Small: 340,
  Medium: 250,
  Large: 180,
  Capital: 110
};

// Section 2a reuses 16.28's role-multiplier table (Scout 1.5x, Multi-role
// 1.0x, Combat/Gunship 0.9x, Hauler 0.8x, Miner 0.7x), but the fixed player
// roster's actual role names (Digger, Packmule, Kestrel, Journeyman,
// Wildcat, Marauder -- see types.ts's own comment on PlayerShip.role)
// aren't mapped to those archetypes anywhere in the source data. Default
// to neutral (1.0x) until that mapping is decided, rather than guessing.
export const DEFAULT_ROLE_SPEED_MULTIPLIER = 1.0;

// A ship's actual in-Location top speed = hull-size base speed x role
// multiplier (Section 2a, e.g. "a Small Scout hits 510 m/s").
export function inLocationTopSpeed(
  hullTierLabel: NpcHullTierLabel,
  roleMultiplier: number = DEFAULT_ROLE_SPEED_MULTIPLIER
): number {
  return HULL_SIZE_BASE_SPEED_MPS[hullTierLabel] * roleMultiplier;
}
